import { normalizeStreamSource } from "../../../analytics/params/source";

type DeriveCanonicalStreamSourceInput = {
  pathname: string;
  area?: string;
  streamId?: string;
  streamSlug?: string;
};

function getChannelPathSource(pathname: string): string | undefined {
  const match = pathname.match(/^\/channel\/([^/]+)(?:\/([^/]+))?/);
  if (!match) {
    return undefined;
  }

  const [, channelSlug, streamSlug] = match;
  return streamSlug
    ? `channel/${channelSlug}/${streamSlug}`
    : `channel/${channelSlug}`;
}

function getInternalStreamSource(streamId: string): string | undefined {
  const parts = streamId.split(".");
  if (parts.length < 5 || parts[0] !== "_internal" || parts[1] !== "gc") {
    return undefined;
  }

  const appIndex = parts.indexOf("app");
  if (appIndex === -1 || appIndex + 2 >= parts.length) {
    return undefined;
  }

  const channelPart = parts[appIndex + 1];
  const streamPart = parts.slice(appIndex + 2).join(".");

  if (channelPart === "home") {
    if (streamPart === "index") {
      return "channel/gc";
    }

    return `channel/gc/${streamPart}`;
  }

  if (channelPart === "originals") {
    return "channel/originals";
  }

  if (streamPart === "index") {
    return `channel/${channelPart}`;
  }

  return `channel/${channelPart}/${streamPart}`;
}

export function deriveCanonicalStreamSource({
  pathname,
  area,
  streamId,
  streamSlug,
}: DeriveCanonicalStreamSourceInput): string | undefined {
  if (streamSlug) {
    return normalizeStreamSource(streamSlug);
  }

  if (area === "home") {
    const routeSource = getChannelPathSource(pathname);
    if (routeSource) {
      return routeSource;
    }

    if (pathname === "/") {
      return "channel/gc";
    }
  }

  if (area === "gc-originals" && pathname.includes("/originals")) {
    return "channel/originals";
  }

  if (streamId) {
    return getInternalStreamSource(streamId) ?? normalizeStreamSource(streamId);
  }

  return undefined;
}
